import React from 'react'
import { Marker, InfoWindow } from '@react-google-maps/api'
import mapIcon from 'assets/svg/map-icon.svg'
import { format } from 'date-fns'

export default function EventMapMarker(props) {
  const { event, isActive, setIsActive } = props

  return (
    <Marker
      position={{
        lat: event.address.location?.lat,
        lng: event.address.location?.lng,
      }}
      onClick={() => {
        if (setIsActive) {
          setIsActive(true)
        }
      }}
      icon={{
        url: mapIcon,
        scaledSize: {
          width: 50,
          height: 50,
        },
      }}
    >
      {isActive && (
        <InfoWindow
          position={{
            lat: event.address.location?.lat,
            lng: event.address.location?.lng,
          }}
          onCloseClick={() => {
            setIsActive(false)
          }}
        >
          {event.caterer ? (
            <CatererBox {...props} />
          ) : (
            <EventBox {...props} />
          )}
        </InfoWindow>
      )}
    </Marker>
  )
}

function CatererBox({ event }) {

  return (
    <div className="">
      {event.caterer.photo && (
        <div className="h-24 w-11/12 md:w-32 block md:inline-block">
          <div
            className="h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('${event.caterer.photo.url}')`,
            }}
          />
        </div>
      )}
      <div className="pl-0 pt-1 md:mx-2 md:pt-0 align-top block md:inline-block">
        <a
          href={`/${event.caterer.slug}/`}
          className={[
            'block font-platform text-lg text-blue mb-2',
            'hover:underline',
          ]}
        >
          {event.caterer.name}
        </a>
        <div className="font-light text-gray-900 leading-normal">
          <div className="break-words">
            {event.location}
          </div>
          <div className="break-words">
            <span>From </span>
            <span className="font-bold">{format(event.start_date, 'M/d h:mm a')}</span>
            <span> to </span>
            <span className="font-bold">{format(event.end_date, 'M/d h:mm a')}</span>
          </div>
          <div className="mt-2">
            <a
              className="text-blue block"
              href={`/${event.caterer.slug}/`}
              children="View Menu"
            />
          </div>
        </div>
      </div>
      {event.special_offers && (
        <div className="font-light italic text-sm my-3">
          {event.special_offers}
        </div>
      )}
    </div>
  )
}

function EventBox({ event }) {

  return (
    <div>
      {event.photo && (
        <div className="h-24 w-11/12 md:w-32 block md:inline-block">
          <div
            className="h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('${event.photo.url}')`,
            }}
          />
        </div>
      )}
      <div className="pl-0 pt-1 md:mx-2 md:pt-0 align-top block md:inline-block">
        <a
          href={`/events/${event.id}/`}
          className={[
            'block font-platform text-lg text-blue mb-2',
            'hover:underline',
          ]}
        >
          {event.title || event.occasion?.name}
        </a>
        <div className="font-light text-gray-900 leading-normal">
          <div className="break-words">
            {event.address?.formatted}
          </div>
          <div className="break-words">
            <span>From </span>
            <span className="font-bold">{format(event.start_date, 'M/d h:mm a')}</span>
            <span> to </span>
            <span className="font-bold">{format(event.end_date, 'M/d h:mm a')}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
